const BlankLink = () => {
  return <div> </div>
}

export default BlankLink
